/** @jsxImportSource @emotion/react */

import { DocType, DocumentView } from './DocumentView'

const PrivacyPolicy = () => {
    return <DocumentView type={DocType.privacyPolicy} />
}

export { PrivacyPolicy }
